import { SIDEBAR_VALUE } from '../../sidebarValues';
export const CLINICAL_NOTE_TYPES = [
  'Address',
  'Appointment',
  'Clinical Note',
  'Consent',
  'Contact',
  'Process',
  'Referral',
  'Sample',
  'Test',
  'Tissue Pathology',
  'Treatment',
  'Risk Factor'
];

const HANDOFF = {
  Disease: {
    event: 'open-disease-record',
    section: SIDEBAR_VALUE.diagnoses,
    label: 'Disease'
  },
  Phenotype: {
    event: 'open-phenotype-record',
    section: SIDEBAR_VALUE.phenotypes,
    label: 'Phenotype'
  },
  Genotype: {
    event: 'open-genotype-record',
    section: SIDEBAR_VALUE.genotypes,
    label: 'Genotype'
  }
};

const PREGNANCY_ROUTE = {
  section: SIDEBAR_VALUE.reproductive,
  sidebarKey: 'openReproRecordId'
};

const READ_ONLY_TYPES = ['Risk Score'];

export const routeForType = (noteType) => {
  if (!noteType || READ_ONLY_TYPES.includes(noteType)) return null;
  if (CLINICAL_NOTE_TYPES.includes(noteType))
    return { kind: 'dialog', noteType };
  const handoff = HANDOFF[noteType];
  if (handoff) return { kind: 'handoff', noteType, ...handoff };
  if (noteType === 'Pregnancy')
    return { kind: 'pregnancy', noteType, ...PREGNANCY_ROUTE };
  return null;
};

export const canOpenType = (noteType) => routeForType(noteType) !== null;

export const CREATABLE_TYPES = [
  ...CLINICAL_NOTE_TYPES,
  'Disease',
  'Phenotype',
  'Genotype'
].sort((a, b) => a.localeCompare(b));
